(function () {
  const drawer = document.querySelector('[data-custom-cart-drawer]');
  if (!drawer) return;

  const selectors = {
    panel: '.custom-cart-drawer__panel',
    content: '[data-custom-cart-drawer-content]',
    refresh: '[data-custom-cart-drawer-refresh]',
    body: '[data-custom-cart-drawer-body]',
    close: '[data-custom-cart-drawer-close]',
    item: '[data-custom-cart-drawer-item]',
    remove: '[data-custom-cart-drawer-remove]',
    quantity: '[data-quantity-input]',
    quantityPlus: '[data-quantity-plus]',
    quantityMinus: '[data-quantity-minus]',
    tick: '[data-custom-cart-drawer-tick-upsell]',
    note: '[data-custom-cart-drawer-note]',
    discountInput: '[data-custom-cart-drawer-discount-input]',
    discountApply: '[data-custom-cart-drawer-discount-apply]',
    checkoutDiscount: '[data-custom-cart-drawer-checkout-discount]',
    discountMessage: '[data-custom-cart-drawer-discount-message]',
    couponDetails: '.custom-cart-drawer__coupon',
    error: '[data-custom-cart-drawer-error]',
    timer: '[data-custom-cart-drawer-timer]',
    timerValue: '[data-custom-cart-drawer-timer-value]',
    headerCart: '.site-header-cart--button',
    productForm: 'form[action*="/cart/add"]',
    quickBuy: '[data-quick-buy][data-variant-id]',
  };

  const routes = window.Theme && window.Theme.routes ? window.Theme.routes : {};
  const sectionUrl = drawer.dataset.sectionUrl || '/?section_id=custom-cart-drawer-items';
  const content = drawer.querySelector(selectors.content);
  const panel = drawer.querySelector(selectors.panel);
  const timer = drawer.querySelector(selectors.timer);
  const timerValue = drawer.querySelector(selectors.timerValue);
  const timerEnabled = drawer.dataset.timerEnabled === 'true';
  const timerMinutes = Math.max(parseFloat(drawer.dataset.timerMinutes || '5'), 0);
  const timerCooldownHours = Math.max(parseFloat(drawer.dataset.timerCooldownHours || '24'), 0);
  const moneyFormat = drawer.dataset.moneyFormat || '${{amount}}';
  const timerEndKey = 'aquascape_cart_drawer_timer_ends_at';
  const timerHiddenKey = 'aquascape_cart_drawer_timer_hidden_until';
  const discountCodeKey = 'aquascape_cart_drawer_discount_code';
  const couponOpenKey = 'aquascape_cart_drawer_coupon_open';

  let lastFocus = null;
  let timerInterval = null;
  let isRefreshing = false;

  function getFocusable() {
    return panel.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;

    const focusable = Array.from(getFocusable()).filter((element) => element.offsetParent !== null || element === document.activeElement);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openDrawer() {
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--custom-cart-drawer-scrollbar-width', `${Math.max(scrollbarWidth, 0)}px`);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('custom-cart-drawer-lock');
    startTimerIfNeeded();
    setTimeout(() => {
      const closeButton = drawer.querySelector('[data-custom-cart-drawer-close].custom-cart-drawer__close');
      (closeButton || panel).focus();
    }, 20);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('custom-cart-drawer-lock');
    document.documentElement.style.removeProperty('--custom-cart-drawer-scrollbar-width');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  function setLoading(isLoading) {
    drawer.classList.toggle('is-loading', isLoading);
    content.querySelectorAll('button, input, textarea').forEach((element) => {
      if (isLoading) {
        element.setAttribute('disabled', 'disabled');
      } else {
        element.removeAttribute('disabled');
      }
    });
  }

  function dispatchCartCount(cart) {
    window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
  }

  function formatMoney(cents, cart) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency',
      currency: cart?.currency || 'AUD',
    }).format(cents / 100);
  }

  function updateSubtotal(cart) {
    const subtotal = content.querySelector('.custom-cart-drawer__subtotal-value');
    if (!subtotal || !cart || typeof cart.total_price !== 'number') return;
    subtotal.innerHTML = formatMoney(cart.total_price, cart);
  }

  function syncDiscountCode(code) {
    const discountCode = typeof code === 'string' ? code.trim() : (sessionStorage.getItem(discountCodeKey) || '');
    const checkoutDiscount = content.querySelector(selectors.checkoutDiscount);
    const discountInput = content.querySelector(selectors.discountInput);

    if (checkoutDiscount) checkoutDiscount.value = discountCode;
    if (discountInput && !discountInput.value) discountInput.value = discountCode;
  }

  function restoreCouponState() {
    const details = content.querySelector(selectors.couponDetails);
    if (!details) return;

    const shouldBeOpen = sessionStorage.getItem(couponOpenKey) === 'true';
    details.open = shouldBeOpen;
  }

  async function renderDrawerSection() {
    const response = await fetch(sectionUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error('Unable to refresh cart drawer.');

    const html = await response.text();
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    const next = wrapper.querySelector(selectors.refresh);
    if (!next) throw new Error('Cart drawer refresh markup was not found.');

    content.innerHTML = next.outerHTML;
    syncDiscountCode();
    restoreCouponState();
  }

  async function getCart() {
    const response = await fetch(`${routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart.');
    return response.json();
  }

  async function refreshDrawer(options = {}) {
    if (isRefreshing) return null;
    isRefreshing = true;
    setLoading(true);

    try {
      await renderDrawerSection();

      let cart = await getCart();
      dispatchCartCount(cart);

      if (cart.item_count === 0) {
        localStorage.removeItem(timerEndKey);
        hideTimer();
      }

      startTimerIfNeeded();
      return cart;
    } finally {
      isRefreshing = false;
      setLoading(false);
    }
  }

  async function changeLine(line, quantity) {
    drawer.classList.add('is-updating-cart');
    setLoading(true);

    try {
      const response = await fetch(routes.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity }),
      });

      const cart = await response.json();
      if (!response.ok || cart.errors) {
        throw new Error(cart.errors || cart.description || 'Unable to update cart.');
      }

      dispatchCartCount(cart);
      updateSubtotal(cart);
      drawer.classList.remove('is-updating-cart');
      await refreshDrawer();
      return cart;
    } finally {
      drawer.classList.remove('is-updating-cart');
      if (!isRefreshing) setLoading(false);
    }
  }

  async function addVariant(variantId, quantity = 1) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    return addFormData(formData);
  }

  async function addFormData(formData) {
    setLoading(true);

    try {
      const response = await fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData,
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add item to cart.');
      }

      await refreshDrawer();
      openDrawer();
      return data;
    } finally {
      if (!isRefreshing) setLoading(false);
    }
  }

  async function updateNote(note) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note }),
    });

    const cart = await response.json();
    if (!response.ok || cart.errors) {
      throw new Error(cart.errors || 'Unable to update cart note.');
    }

    dispatchCartCount(cart);
  }

  async function applyDiscountCode(code) {
    const discountCode = code.trim();
    if (!discountCode) {
      sessionStorage.removeItem(discountCodeKey);
      syncDiscountCode('');
      showMessage(selectors.discountMessage, '');
      return;
    }

    sessionStorage.setItem(discountCodeKey, discountCode);
    syncDiscountCode(discountCode);
    setLoading(true);

    try {
      const applied = await applyDiscountInBackground(discountCode);
      if (!applied) throw new Error('Unable to apply discount code.');

      const refreshedCart = await refreshDrawer();
      const normalizedCode = discountCode.toLowerCase();
      const hasMatchingDiscount = (refreshedCart?.cart_level_discount_applications || []).some((application) => {
        return String(application?.title || '').trim().toLowerCase() === normalizedCode;
      });

      if (hasMatchingDiscount) {
        syncDiscountCode(discountCode);
        showMessage(selectors.discountMessage, 'Discount code applied.', 'success');
      } else {
        sessionStorage.removeItem(discountCodeKey);
        syncDiscountCode('');
        showMessage(selectors.discountMessage, 'Enter a valid code');
      }
    } finally {
      if (!isRefreshing) setLoading(false);
    }
  }

  async function applyDiscountInBackground(discountCode) {
    const checkoutDiscountPath = `/checkout?discount=${encodeURIComponent(discountCode)}&edge_redirect=true&skip_shop_pay=true`;
    const discountPath = `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(routes.cart_url || '/cart')}`;

    if (await requestDiscountPath(checkoutDiscountPath)) return true;
    if (await requestDiscountPath(discountPath)) return true;

    return applyDiscountWithIframe(checkoutDiscountPath).then((success) => success || applyDiscountWithIframe(discountPath));
  }

  async function requestDiscountPath(discountPath) {
    try {
      const response = await fetch(discountPath, {
        cache: 'no-store',
        credentials: 'same-origin',
        redirect: 'manual',
      });

      if (response.ok || response.type === 'opaqueredirect' || (response.status >= 300 && response.status < 400)) return true;
    } catch (error) {
      // Fall back to an iframe below. Some Shopify preview routes reject fetches.
    }

    return false;
  }

  function applyDiscountWithIframe(discountPath) {
    return new Promise((resolve) => {
      const iframe = document.createElement('iframe');
      let settled = false;
      const timeout = window.setTimeout(() => finish(false), 6000);

      function finish(success) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        iframe.remove();
        resolve(success);
      }

      iframe.hidden = true;
      iframe.tabIndex = -1;
      iframe.setAttribute('aria-hidden', 'true');
      iframe.addEventListener('load', () => finish(true), { once: true });
      iframe.addEventListener('error', () => finish(false), { once: true });
      iframe.src = discountPath;
      document.body.appendChild(iframe);
    });
  }

  function showMessage(selector, message, tone) {
    const messageElement = content.querySelector(selector) || content.querySelector(selectors.error);
    if (!messageElement) return;

    messageElement.textContent = message;
    messageElement.classList.toggle('custom-cart-drawer__message--success', tone === 'success');
  }

  function showError(error) {
    showMessage(selectors.error, error && error.message ? error.message : 'Something went wrong. Please try again.');
  }

  function hideTimer() {
    if (timer) timer.hidden = true;
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
  }

  function formatTime(ms) {
    const totalSeconds = Math.max(Math.ceil(ms / 1000), 0);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':');
  }

  function startTimerIfNeeded() {
    if (!timerEnabled || !timer || !timerValue || timerMinutes <= 0) return;

    const body = content.querySelector(selectors.body);
    const itemCount = Number(body?.dataset.cartItemCount || 0);
    if (!itemCount) {
      hideTimer();
      return;
    }

    const now = Date.now();
    const hiddenUntil = Number(localStorage.getItem(timerHiddenKey) || 0);
    if (hiddenUntil && hiddenUntil > now) {
      hideTimer();
      return;
    }

    let endsAt = Number(localStorage.getItem(timerEndKey) || 0);
    if (!endsAt || endsAt <= now) {
      endsAt = now + timerMinutes * 60 * 1000;
      localStorage.setItem(timerEndKey, String(endsAt));
    }

    timer.hidden = false;
    if (timerInterval) clearInterval(timerInterval);

    const tick = () => {
      const remaining = endsAt - Date.now();
      if (remaining <= 0) {
        localStorage.removeItem(timerEndKey);
        if (timerCooldownHours > 0) {
          localStorage.setItem(timerHiddenKey, String(Date.now() + timerCooldownHours * 60 * 60 * 1000));
        }
        hideTimer();
        return;
      }
      timerValue.textContent = formatTime(remaining);
    };

    tick();
    timerInterval = setInterval(tick, 1000);
  }

  function shouldHandleProductForm(form) {
    if (!form || !form.matches(selectors.productForm)) return false;
    if (form.querySelector('[type="file"]')) return false;
    return true;
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!shouldHandleProductForm(form)) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    addFormData(new FormData(form)).catch(showError);
  }, true);

  document.addEventListener('click', (event) => {
    const headerCart = event.target.closest(selectors.headerCart);
    if (headerCart) {
      event.preventDefault();
      openDrawer();
      refreshDrawer().catch(() => {});
      return;
    }

    const quickBuy = event.target.closest(selectors.quickBuy);
    if (quickBuy) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addVariant(quickBuy.dataset.variantId, 1).catch(showError);
      return;
    }

    const quantityButton = event.target.closest(`${selectors.quantityPlus}, ${selectors.quantityMinus}`);
    if (quantityButton && drawer.contains(quantityButton)) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const item = quantityButton.closest(selectors.item);
      const quantityInput = item ? item.querySelector(selectors.quantity) : null;
      if (!item || !quantityInput) return;

      const step = parseFloat(quantityInput.dataset.incrementValue || quantityInput.step || '1') || 1;
      const min = parseFloat(quantityInput.min || step) || step;
      const current = parseFloat(quantityInput.value || min) || min;
      const nextQuantity = quantityButton.matches(selectors.quantityPlus)
        ? current + step
        : Math.max(current - step, min);

      if (nextQuantity === current) return;
      quantityInput.value = String(nextQuantity);
      item.classList.add('is-updating');

      changeLine(Number(item.dataset.line), nextQuantity).catch((error) => {
        showError(error);
        refreshDrawer().catch(() => {});
      });
      return;
    }

    if (event.target.closest(selectors.close)) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const removeButton = event.target.closest(selectors.remove);
    if (removeButton) {
      event.preventDefault();
      const item = removeButton.closest(selectors.item);
      if (!item) return;
      item.classList.add('is-removing');
      changeLine(Number(item.dataset.line), 0).catch(showError);
      return;
    }

    const tick = event.target.closest(selectors.tick);
    if (tick) {
      event.preventDefault();
      const variantId = tick.dataset.variantId;
      if (!variantId) return;
      const checkbox = tick.querySelector('input');
      if (checkbox) checkbox.checked = true;
      addVariant(variantId, 1).catch((error) => {
        if (checkbox) checkbox.checked = false;
        showMessage('[data-custom-cart-drawer-tick-message]', error.message);
      });
      return;
    }

    const discountButton = event.target.closest(selectors.discountApply);
    if (discountButton) {
      event.preventDefault();
      const input = content.querySelector(selectors.discountInput);
      const code = input ? input.value.trim() : '';
      sessionStorage.setItem(couponOpenKey, 'true');
      applyDiscountCode(code).catch(showError);
    }
  }, true);

  document.addEventListener('change', (event) => {
    const quantity = event.target.closest(selectors.quantity);
    if (quantity) {
      const item = quantity.closest(selectors.item);
      if (!item) return;
      item.classList.add('is-updating');
      changeLine(Number(item.dataset.line), Number(quantity.value)).catch((error) => {
        showError(error);
        refreshDrawer().catch(() => {});
      });
    }
  });

  let noteTimer = null;
  document.addEventListener('input', (event) => {
    const note = event.target.closest(selectors.note);
    if (!note) return;

    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      updateNote(note.value).catch((error) => {
        showError(error);
      });
    }, 500);
  });

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches(selectors.couponDetails)) return;
    sessionStorage.setItem(couponOpenKey, details.open ? 'true' : 'false');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
      return;
    }
    trapFocus(event);
  });

  window.CustomCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer,
    addVariant,
  };

  syncDiscountCode();
})();
